import { Stack, Divider, Skeleton, Typography } from '@mui/material'
import type { FC } from 'react'

import { toSkillLevelLabel } from '@/utils/skillLevel'
import type { Squad } from '@/utils/squad'
import { toSquadsLabel } from '@/utils/squad'

import Detail from './Detail'

export type Props = {
  loading?: boolean
  fullName?: string
  skillLevel?: number
  squads?: Squad[]
}

const AppBarContent: FC<Props> = ({ loading = true, fullName, skillLevel, squads }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{ flexGrow: 1 }}
  >
    {loading ? (
      <span data-testid="app-bar-content-title-loading">
        <Skeleton variant="text" width={50} />
      </span>
    ) : (
      <Typography component="h1" variant="h6">
        {fullName}
      </Typography>
    )}
    <Stack
      direction="row"
      alignItems="center"
      spacing={4}
      divider={<Divider orientation="vertical" flexItem />}
    >
      <Detail label="Level" value={toSkillLevelLabel(skillLevel)} loading={loading} />
      <Detail label="Squads" value={toSquadsLabel(squads)} loading={loading} />
    </Stack>
  </Stack>
)

export default AppBarContent
